{
  "version": 1,
  "asset_id": "8d76a1c5-decc-4e46-b4f7-afb279a2308b",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8d76a1c5-decc-4e46-b4f7-afb279a2308b/sleeve-to-bypass-completed-en.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8d76a1c5-decc-4e46-b4f7-afb279a2308b/sleeve-to-bypass-completed-en.png",
  "original_filename": "sleeve-to-bypass-completed-en.png",
  "size": 333361,
  "content_type": "image/png",
  "created_at": "2026-10-05T12:46:16Z"
}
